// extracted by mini-css-extract-plugin
export default {"cta":"MailCta_cta__t-zdE","button":"MailCta_button__cwZuF","address":"MailCta_address__Lm3QS","hint":"MailCta_hint__2tboT"};